<div class="email-audit-block">
    <div class="title_heading">
        <h1>Emails Audit</h1>
    </div>

    <div class="div-container">
        <div class="search-container">
            <div class="search-left-group">
                <kendo-textbox #textbox [(ngModel)]="searchValue" 
                (keydown.enter)="GetAuditEmails()"
                    placeholder="Search by Material Name or Technical Name" class="search-input">
                    <ng-template kendoTextBoxPrefixTemplate>
                        <fa-icon [icon]="iconPacks.FASEARCH"></fa-icon>
                    </ng-template>
                    <ng-template kendoTextBoxSuffixTemplate>
                    </ng-template>
                </kendo-textbox>
                <button type="button" kendoButton class="btn-save  k-button-lg"
                    (click)="GetAuditEmails()">Search</button>
                <button type="button" kendoButton class="btn-cancel  k-button-lg" (click)="reset()">Reset</button>
            </div>

            <div class="search-right-group">
                <div class="advanced-filter-toggle" (click)="isAdvancedFilterOpened = !isAdvancedFilterOpened;">
                    <span>{{ !isAdvancedFilterOpened ? 'Show' :
                        'Close'}} Advanced</span>&nbsp;
                    <fa-icon class="icon-packs" [icon]="iconPacks.FACARETUP" *ngIf="isAdvancedFilterOpened"></fa-icon>
                    <fa-icon class="icon-packs" [icon]="iconPacks.FACARETDOWN"
                        *ngIf="!isAdvancedFilterOpened"></fa-icon>
                </div>
            </div>

        </div>

        <ng-container *ngIf="isAdvancedFilterOpened">
            <div class="filter-container">
                <div class="filter-item">
                    <kendo-label>Material Name</kendo-label>
                    <kendo-dropdownlist class="search-dd" [data]="filterMaterialNameList" [filterable]="true"
                        (filterChange)="handleMaterialFilter($event)"
                        [(ngModel)]="filterObj.MaterialName"></kendo-dropdownlist>
                </div>
                <div class="filter-item">
                    <kendo-label>User </kendo-label>
                    <kendo-dropdownlist width="200" class="search-dd" [data]="filterUserList" [filterable]="true"
                        textField="name" valueField="userId" [(ngModel)]="filterObj.user"
                        (filterChange)="handleUserFilter($event)"></kendo-dropdownlist>
                </div>
                <div class="filter-item">
                    <kendo-label>Start Date</kendo-label>
                    <kendo-datepicker (valueChange)="changeStartDate('start')" [(ngModel)]="filterObj.startDate"
                        [format]="dateFormat"  class="search-dd" [max]="today" ></kendo-datepicker>
                </div>
                <div class="filter-item">
                    <kendo-label>End Date</kendo-label>
                    <kendo-datepicker (valueChange)="changeStartDate('end')" [(ngModel)]="filterObj.endDate"
                        [format]="dateFormat" class="search-dd" [max]="today" ></kendo-datepicker>
                </div>
            </div>
        </ng-container>
    </div>

    <div class=" k-d-flex k-justify-content-end">
        <button kendoButton fillMode="outline" class="tab-action-item" (click)="GetAuditEmailsForExcel()">
            <fa-icon [icon]="iconPacks.FAFILEEXCEL"></fa-icon> Export
        </button>
    </div>

    <div>
        <kendo-grid class="mt-10" [data]="emailsAuditList" [resizable]="true" [sortable]="true"
            (sortChange)="sortChange($event)" [sort]="sort">
            <ng-template kendoGridNoRecordsTemplate>
                <div class="norecordsmwobuild">No Audits to show...</div>
            </ng-template>
            <kendo-grid-column title="Material" field="materialName" [width]="150"> </kendo-grid-column>
            <kendo-grid-column title="approved plants" field="materialApprovedPlants">
                <ng-template kendoGridHeaderTemplate>
                    <div class="header-with-tooltip">
                        Approved Plants
                        <fa-icon class="header-info-icon" [icon]="iconPacks.FAINFOCIRCLE" kendoTooltip position="top"
                            title="Approved plantes for this Material"></fa-icon>
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container *ngIf="dataItem.ManufacturingPlants?.length > 0">
                        <p> Manufacturing Plants: </p>
                        <span [innerHTML]="dataItem?.ManufacturingPlants?.join('\<br />') || ''"></span>
                        <br/>
                    </ng-container>
                    <ng-container *ngIf="dataItem.WarehousePlants?.length > 0">
                    
                        <p> Warehouse Plants: </p>
                        <span *ngIf="dataItem.WarehousePlants?.length > 0" [innerHTML]="dataItem?.WarehousePlants?.join('\<br />') || ''"></span>
                        <br/>
                    </ng-container>
                    <ng-container *ngIf="dataItem.removedPlants?.length > 0">
                        <br/>
                        <p style="color: red;"> The following plants were deactivated/removed: </p>
                        <span [innerHTML]="dataItem.removedPlants?.join('\<br />') || ''"></span>
                    </ng-container>
                </ng-template>

            </kendo-grid-column>
            <kendo-grid-column title="user plants" field="userPlants">
                <ng-template kendoGridHeaderTemplate>
                    <div class="header-with-tooltip">
                        User Plants
                        <fa-icon class="header-info-icon" [icon]="iconPacks.FAINFOCIRCLE" kendoTooltip position="top"
                            title="Plants associated with User (showing only the ones related to this Materials) "></fa-icon>
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.userPlants?.length === 0"> </span>
                    <span *ngIf="dataItem.userPlants?.length > 0"
                        [innerHTML]="dataItem.userPlants?.join('\<br/>') || ''"></span>
                </ng-template>

            </kendo-grid-column>
            <kendo-grid-column title="user" field="userName" [width]="150">
            </kendo-grid-column>
            <kendo-grid-column title="Email sent on" field="materialLoggedDateTime" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.materialLoggedDateTime | dateFormatter: 'YYYY-MM-dd'}}</span>
                </ng-template>

            </kendo-grid-column>

        </kendo-grid>

        <app-custom-pager [pageSize]="pageSize" [skip]="skip" [total]="emailsAuditList.total"
            (pageChange)="pageChange($event)"></app-custom-pager>

    </div>
</div>